import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import {
    catchErrorLogRet,
    mapCreate,
    mapDelete,
    mapList,
} from '../../common/rest.operators';

import { RowDto } from './row-dto.model';
import { TableDto } from './table-dto.model';

@Injectable({ providedIn: 'root' })
export class TableEditorService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    listTables(): Observable<TableDto[]> {
        return this._http
            .get(`${this._appConfig.API_ENDPOINTS.USER}/table-editor`)
            .pipe(mapList(), catchErrorLogRet([]));
    }

    createRow(tableId: number, row: RowDto): Observable<string> {
        return this._http
            .post(
                `${this._appConfig.API_ENDPOINTS.USER}/table-editor/${tableId}/rows`,
                row,
                { observe: 'response' },
            )
            .pipe(
                mapCreate(),
                map((ret) => ret || ''), // no location header is returned
                catchErrorLogRet(null),
            );
    }

    deleteRow(tableId: number, row: RowDto): Observable<boolean> {
        return this._http
            .post(
                `${this._appConfig.API_ENDPOINTS.USER}/table-editor/${tableId}/rows/delete`,
                row,
            )
            .pipe(mapDelete(), catchErrorLogRet(false));
    }

    listRows(tableId: number): Observable<RowDto[]> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.USER}/table-editor/${tableId}/rows`,
            )
            .pipe(mapList(), catchErrorLogRet([]));
    }
}
